import { render, staticRenderFns } from "./Competizioni.vue?vue&type=template&id=91b38bd8&"
import script from "./Competizioni.vue?vue&type=script&lang=js&"
export * from "./Competizioni.vue?vue&type=script&lang=js&"
import style0 from "./Competizioni.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports